import React from 'react';

const NotFound = () => {
    return (
        <div className="jumbotron">
            <h1 className="display-4 text-dark">404! Error</h1>
            <h3>Data Not found</h3>
            
        </div>
    );
};

export default NotFound;